import React, { useEffect, useState } from "react";
import CInput from "../../../components/CInput";
import {
  CircularProgress,
  IconButton,
  InputAdornment,
  Button,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { Setting } from "../../../utils/Setting";
import { getApiData } from "../../../utils/APIHelper";

const errorObj = {
  passwordErr: false,
  passwordMsg: "",
  newPasswordErr: false,
  newPasswordMsg: "",
};

function Reset() {
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [errObj, setErrObj] = useState(errorObj);

  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location?.state?.data ? location?.state?.data : {};
  const [timerCount, setTimer] = useState(60);
  const [btnLoad, setBtnLoad] = useState("");
  const [resendViewVisible, setResendViewVisible] = useState(false);

  const passwordRegex =
    /^(((?=.*[a-z])(?=.*[A-Z]))((?=.*[a-z]))(?=.*[!@#$%+:^=<(){}[\]~>_?`|'";,.&*€₹£])((?=.*[A-Z])))(?=.{8,})/;

  useEffect(() => {
    if (timerCount === 0) {
      setResendViewVisible(true);
    }
    if (!timerCount) {
      return;
    }

    const intervalId = setInterval(() => {
      setTimer(timerCount - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timerCount]);

  useEffect(() => {
    // Reset all state variables to clear prefilled data
    setOtp("");
    setPassword("");
    setNewPassword("");
    setShowPassword(false);
    setShowNewPassword(false);
    setErrObj(errorObj);
    setTimer(60);
    setResendViewVisible(false);
  }, []);

  // this function resend otp to the user
  async function resendOtp() {
    setBtnLoad("resend");
    try {
      const response = await getApiData(Setting.endpoints.resendOtp, "POST", {
        email: locationState,
        verify_type: "email",
      });

      console.log("response ====resend otp=>>> ", response);
      if (response.success) {
        setTimer(60);
        setResendViewVisible(false);
      } else {
        toast.error(response.message);
      }
      setBtnLoad("");
    } catch (error) {
      console.log("🚀 ~ file: index.js:88 ~ resendOtp ~ error:", error);
      toast.error(error.toString() || "Something gone wrong! Please try again");
      setBtnLoad("");
    }
  }

  // this function checks validation of login field
  function validation() {
    const error = { ...errObj };
    let valid = true;

    //validate otp
    if (isEmpty(otp)) {
      valid = false;
      error.otpErr = true;
      error.otpMsg = "Please enter OTP";
    }

    // validate password
    if (isEmpty(password)) {
      valid = false;
      error.passwordErr = true;
      error.passwordMsg = "Please enter new password";
    } else if (!passwordRegex.test(password)) {
      valid = false;
      error.passwordErr = true;
      error.passwordMsg =
        "Password must include more than 8 characters, at least one number, one letter, one capital letter and one symbol";
    } else if (password.length < 8) {
      valid = false;
      error.passwordErr = true;
      error.passwordMsg = "Password length must be of 8-15";
    } else if (password !== newPassword) {
      valid = false;
      error.passwordErr = true;
      error.passwordMsg = "New password and confirm password must be same";
    }

    // validate newPassword
    if (isEmpty(newPassword)) {
      valid = false;
      error.newPasswordErr = true;
      error.newPasswordMsg = "Please enter confirm password";
    } else if (!passwordRegex.test(newPassword)) {
      valid = false;
      error.newPasswordErr = true;
      error.newPasswordMsg =
        "Confirm Password must include more than 8 characters, at least one number, one letter, one capital letter and one symbol";
    } else if (newPassword.length < 8) {
      valid = false;
      error.newPasswordErr = true;
      error.newPasswordMsg = "Confirm password length must be of 8-15";
    } else if (newPassword !== password) {
      valid = false;
      error.newPasswordErr = true;
      error.newPasswordMsg = "New password and confirm password must be same";
    }

    setErrObj(error);
    if (valid) {
      updatePasswordByOtp();
    }
  }

  async function updatePasswordByOtp() {
    try {
      setBtnLoad("reset");
      const response = await getApiData(
        Setting.endpoints.updatePasswordOtp,
        "POST",
        {
          otp,
          password,
          verify_type: "email",
        }
      );

      if (response.success) {
        toast.success(response.message);
        navigate("/user-login");
      } else {
        toast.error(response.message);
      }
      setBtnLoad("");
    } catch (error) {
      setBtnLoad("");
      console.log("error=====>>>>>", error);
      toast.error(error.toString());
    }
  }

  return (
    <>
      <CInput
        outline
        label="OTP"
        placeholder="Enter OTP"
        value={otp}
        onChange={(e) => {
          setOtp(e.target.value);
          setErrObj({ ...errObj, otpErr: false, otpMsg: "" });
        }}
        inputProps={{ maxLength: 5 }}
        white={false}
        error={errObj.otpErr}
        helpertext={errObj.otpMsg}
      />

      <CInput
        outline
        label="New Password"
        placeholder="Enter new password"
        value={password}
        passValue={password}
        passwordValidation
        type={showNewPassword ? "text" : "password"}
        onChange={(e) => {
          setPassword(e.target.value);
          setErrObj({
            ...errObj,
            passwordErr: false,
            passwordMsg: "",
          });
        }}
        white={false}
        inputProps={{ maxLength: 15 }}
        error={errObj.passwordErr}
        helpertext={errObj.passwordMsg}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => setShowNewPassword(!showNewPassword)}
            >
              {!showNewPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />

      <CInput
        outline
        label="Confirm Password"
        placeholder="Enter confirm password"
        type={showPassword ? "text" : "password"}
        value={newPassword}
        onChange={(e) => {
          setNewPassword(e.target.value);
          setErrObj({
            ...errObj,
            newPasswordErr: false,
            newPasswordMsg: "",
          });
        }}
        white={false}
        error={errObj.newPasswordErr}
        helpertext={errObj.newPasswordMsg}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => setShowPassword(!showPassword)}
            >
              {!showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "20px",
          marginTop: "3vh",
        }}
      >
        <button
          style={{
            width: "100%",
            backgroundColor: "#fff",
            borderRadius: "12px",
            fontSize: "16px",
            fontWeight: "600",
            boxShadow: "none",
            color: "#0D0D0E",
            border: "1px solid #1212151A",
            padding: "1.5vh 2vw",
            cursor: "pointer",
            fontFamily: "Inter Tight",
            whiteSpace: "nowrap",
          }}
          onClick={() => {
            if (
              btnLoad === "resend" ||
              !resendViewVisible ||
              btnLoad === "otp"
            ) {
              return null;
            } else {
              resendOtp();
            }
          }}
        >
          {btnLoad === "resend" ? (
            <CircularProgress style={{ color: "#fff" }} size={26} />
          ) : resendViewVisible ? (
            "Resend OTP"
          ) : (
            `00:${timerCount}`
          )}
        </button>

        <button
          onClick={validation}
          style={{
            width: "100%",
            padding: "1.5vh 2vw",
            backgroundColor: "#4D6BF6",
            borderRadius: "12px",
            fontSize: "16px",
            fontWeight: "600",
            boxShadow: "none",
            border: "1px solid transparent",
            color: "#fff",
            cursor: "pointer",
            fontFamily: "Inter Tight",
            textAlign: "center",
            whiteSpace: "nowrap",
          }}
        >
          {btnLoad === "reset" ? (
            <CircularProgress style={{ color: "#fff" }} size={26} />
          ) : (
            "Reset Password"
          )}
        </button>
      </div>
    </>
  );
}

export default Reset;
